export default __webpack_public_path__ + "app/views/administration/reporting/confirmation.html";